import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import MapNavbar from "../../components/organisms/mapNavbar/MapNavbar";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./Map.css";
import DraggableComponent from "../../components/organisms/draggableComponent/DraggableComponent";
import IconButton from "@mui/material/IconButton";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LayersIcon from "@mui/icons-material/Layers";
import MapSidebar from "../../components/organisms/mapSidebar/MapSidebar";
import "../../publics//red_star.png";
import LegendComponent from "../../components/organisms/LegendComponent/LegendComponent";
import UserComponent from "../../components/organisms/userComponent/UserComponent";
import TimelineBar from "../../components/organisms/timeLineBar/TimeLineBar";
import Tooltip from "@mui/material/Tooltip";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HistoricSidebar from "../../components/organisms/historicSidebar/HistoricSidebar";
import { assets } from "../../publics/assets";
import NavbarMenu from "../../components/organisms/navbarMenu/NavbarMenu";
import MapStylesSidebar from "../../components/organisms/mapStylesSidebar/MapStylesSidebar";
import { LightModeContext } from "../../hooks/mode/LightModeContextProvider";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import GridViewIcon from "@mui/icons-material/GridView";
import TerrainIcon from "@mui/icons-material/Terrain";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import ForestIcon from "@mui/icons-material/Forest";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import store from "../../redux/store/store";
import {
  addMapControls,
  apply3DBuildings,
  apply3DTerrain,
  initializeMap,
  remove3DBuildings,
  remove3DTerrain,
  renderCustomTooltips,
  renderDrawToolTooltips,
  applyMapLanguage,
} from "../../utils/MapboxUtils";
import { useAccessRights } from "../../hooks/userPermissions/useAccessRights";
import ActiveFiresPanel from "../../components/organisms/activeFires/ActiveFiresPanel";
import { getLocalNowMinusOneHour } from "../../utils/DateTimeUtils";
import { useTranslation } from "react-i18next";
import { updateExportContourButtonTooltip } from "../../utils/drawTools/drawToolsExportControl";
import { updateImportContourButtonTooltip } from "../../utils/drawTools/drawToolsImportControl";
mapboxgl.accessToken = `${process.env.REACT_APP_MAPBOX_PK}`;
const MapTemplate = ({
  showLayersComponent,
  handleDraggableComponentToggle,
  mapContainerRef,
  mapRef,
  is3DTerrain,
  is3DBuildings,
  setIs3DTerrain,
  setIs3DBuildings,
  departements,
  onShowDepartements,
  regions,
  onShowRegions,
  opacities,
  onHandleOpacity,
  isSidebarPropagationOpen,
  onToggleSidebar,
  getDfciGrid,
  dfci,
  onShowDfci,
  onUpdateCurrentZoom,
  onUpdateCurrentBounds,
  currentZoom,
  currentBounds,
  showMeteoComponent,
  handleMeteoComponentToggle,
  soilMoisture,
  onShowSoilMoisture,
  onZoomToGrid,
  dfciCode,
  setDfciCode,
  showLegendComponent,
  handleLegendComponentToggle,
  baresoil,
  onShowBareSoil,
  shrubland,
  onShowShrubland,
  cropland,
  onShowCropland,
  grassland,
  onShowGrassland,
  coniferous,
  onShowConiferous,
  broadleaf,
  onShowBroadleaf,
  pine,
  onShowPine,
  oak,
  onShowOak,
  mixedForest,
  onShowMixedForest,
  leafAreaIndex,
  onShowLai,
  vegetationHeight,
  onShowVegetationHeight,
  biomass,
  onShowBiomass,
  totalFuelLoad,
  onShowTotalFuelLoad,
  demLevel,
  onShowDemLevel,
  water,
  onShowWater,
  urban,
  onShowUrban,
  showUserComponent,
  onShowUserComponent,
  windSpeedData,
  onShowWindSpeedData,
  windDirectionData,
  onShowWindDirection,
  selectedMeteoGetOption,
  onChangeSelectedMeteoOption,
  windSpeed,
  windDirection,
  fuelMoisture,
  temperatureParam,
  handleTemperatureChange,
  handleWindSpeedChange,
  handleWindDirectionChange,
  handleFuelMoistureChange,
  geoJsonResults,
  geoJsonResultAI,
  toggleContourBuildingsVisibility,
  toggleContourVisibility,
  handleSendPolygons,
  onChangeTime,
  selectedTime,
  sliderIndex,
  onChangeSliderIndex,
  getPolygons,
  getPoints,
  currentTimeZone,
  onToggleHistoricSidebar,
  isOpenHistoricSidebar,
  getHistoricFires,
  getHistoricFiresByDate,
  onChangeHistoricFiresStartDate,
  onChangeHistoricFiresEndDate,
  historicFiresStartDate,
  historicFiresEndDate,
  showHistoricFiresList,
  showHistoricFiresByDateList,
  onShowHistoricFiresList,
  onShowHistoricFiresByDateList,
  formattedCurrentDate,
  formattedCurrentTime,
  historicFires,
  filteredHistoricFires,
  onChangeOriginFireRef,
  onChangeOriginFireDate,
  onChangeOriginFireHour,
  onChangeOriginFireLocation,
  originFireRef,
  originFireDate,
  originFireHour,
  originFireLocation,
  contourHour,
  setContourHour,
  contourDate,
  setContourDate,
  handleAddFireId,
  handleRemoveFireId,
  selectedFiresIds,
  getHistoricFiresByIds,
  operationId,
  setFilteredHistoricFiresPolygons,
  handleReset,
  majorRoads,
  onShowMajorRoads,
  showElectricalLines,
  showElectricalStations,
  onShowElectricalLines,
  onShowElectricalStations,
  handleExport,
  showNavbarMenu,
  onShowNavbarMenu,
  initializeDrawTools,
  isSmallScreen,
  toggleMapStylesSidebar,
  showMapStylesSidebar,
  logout,
  railways,
  onShowRailways,
  gazLines,
  onShowGazLines,
  gazRefuelingStations,
  onShowGazRefuelingStations,
  precipitations,
  onShowPrecipitations,
  onShowTemperature,
  temperature,
  relativeHumidity,
  onShowRelativeHumidity,
  meanSeaLevelPressure,
  onShowMeanSeaLevelPressure,
  onShowWindGust,
  windGust,
  updateProfile,
  updatePassword,
  showClock,
  setShowClock,
  showCursorCoords,
  setShowCursorCoords,
  fireStationsData,
  onShowFireStations,
  onShowUserHistoricEvents,
  userHistoricEventsList,
  setLoadingUserEvents,
  getHistoricEventPolygons,
  handleEventSelect,
  modelErrorMessage,
  handleResetOpacity,
  artificielWater,
  onShowArtificielWater,
  reducedWindow,
  onReduceLayersWindow,
  onReduceWeatherWindow,
  onReduceEventCreationWindow,
  onReduceHistoricFiresnWindow,
  onReduceLegendWindow,
  hourlyPrecipitations,
  onShowHourlyPrecipitations,
  currentLoadingMessage,
  setCurrentLoadingMessage,
  buildingsLoading,
  deadFuel,
  onShowDeadFuel,
  weatherRequestDate,
  weatherRequestStartHour,
  setWeatherRequestDate,
  setWeatherRequestStartHour,
  onShowCloudCover,
  cloudCover,
  selectedStyle,
  setSelectedStyle,
  timelineKey,
  weatherCountry,
  setWeatherCountry,
  drawRef,
  closeAllLayers,
  predictionHours,
  setPredictionHours,
  timeStep,
  setTimeStep,
  onShowAllBuildings,
  onHideAllBuildings,
  loadingEventId,
  geoJsonInputContour,
  vegetationCountry,
  setVegetationCountry,
  selectedVegDepartment,
  setSelectedVegDepartment,
  selectedWeatherDepartment,
  setSelectedWeatherDepartment,
  activeFires,
  onShowActiveFires,
  showActiveFiresPanel,
  onToggleActiveFiresPanel,
  activeFiresStartDate,
  onChangeActiveFiresStartDate,
  activeFiresEndDate,
  onChangeActiveFiresEndDate,
  onApplyActiveFiresFilters,
  getActiveFires,
  onReduceActiveFiresWindow,
  hasVisibleHistoricFires,
  activeFiresStartTime,
  onChangeActiveFiresStartTime,
  activeFiresEndTime,
  onChangeActiveFiresEndTime,
  resetLocationTrigger,
  activeFiresBuckets,
  activeFiresCursor,
  onChangeActiveFiresCursor,
  activeFiresPreset,
  onChangeActiveFiresPreset,
  activeFiresDisplayStartDate,
  onChangeActiveFiresDisplayStartDate,
  activeFiresDisplayEndDate,
  onChangeActiveFiresDisplayEndDate,
  defaultHistoricEndDate,
  anyWeatherVisible,
  onDeselectAllEvents,
  loadMoreUserHistoricEvents,
  historicSearchReference,
  onChangeHistoricSearchReference,
    onDeleteHistoricEvent,
}) => {
  const { t, i18n } = useTranslation();
  const geocoderContainerRefSidebar = useRef(null);
  const geocoderContainerRefNavbar = useRef(null);
  const geocoder = useRef(null);
  const geocoderSidebar = useRef(null);
  const { canAccessLayer } = useAccessRights();
  const canAccessHistoric = canAccessLayer("physical_model", "historic");

  const { isLightMode } = useContext(LightModeContext);
  const [userComponentActiveTab, setUserComponentActiveTab] =
    useState("profile");
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [scrollZoom, setScrollZoom] = useState(true);
  const [dragRotate, setDragRotate] = useState(true);
  const [keyboard, setKeyboard] = useState(false);
  const [time, setTime] = useState(new Date());
  const layerAccess = (
    permissionKey,
    serviceName = "display_layers_service",
  ) =>
    permissionKey
      ? { disabled: !canAccessLayer(serviceName, permissionKey) }
      : { disabled: false };
  // Update the clock every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId); // Clean up interval
  }, []);
  useEffect(() => {
    if (geocoderSidebar.current) {
      geocoderSidebar.current.clear();
    }
  }, [resetLocationTrigger]);
  const triggerTooltip = (message) => {
    setTooltipMessage(message);
    setShowTooltip(true);

    // Hide the tooltip after 3 seconds
    setTimeout(() => {
      setShowTooltip(false);
    }, 5000);
  };
  const [moveEvent, setMoveEvent] = useState();
  useEffect(() => {
    if (mapRef.current) {
      scrollZoom
        ? mapRef.current.scrollZoom.enable()
        : mapRef.current.scrollZoom.disable();
      dragRotate
        ? mapRef.current.dragRotate.enable()
        : mapRef.current.dragRotate.disable();
      keyboard
        ? mapRef.current.keyboard.enable()
        : mapRef.current.keyboard.disable();
      // console.log(
      //   "dragRotate.isEnabled:",
      //   mapRef.current.dragRotate.isEnabled(),
      // );
    }
  }, [scrollZoom, dragRotate, keyboard]);
  const onShowUserProfileSection = () => {
    if (showUserComponent && userComponentActiveTab === "profile") {
      onShowUserComponent();
    } else {
      setUserComponentActiveTab("profile");
      if (!showUserComponent) {
        onShowUserComponent();
      }
    }
  };

  const onShowUserHistoricSection = () => {
    if (!canAccessHistoric) return;

    if (showUserComponent && userComponentActiveTab === "eventsHistoric") {
      onShowUserComponent(); // close
    } else {
      setUserComponentActiveTab("eventsHistoric");
      if (!showUserComponent) {
        onShowUserComponent(); // open
      }
      onShowUserHistoricEvents();
    }
  };
  const changePitch = (delta) => {
    const currentPitch = mapRef.current.getPitch();
    const newPitch = Math.max(0, Math.min(60, currentPitch + delta)); // Limit pitch between 0 and 60
    mapRef.current.setPitch(newPitch);
  };

  useEffect(() => {
    const disableNorthButton = (disable) => {
      const northButton = document.querySelector(".mapboxgl-ctrl-compass");
      if (northButton) {
        northButton.style.display = disable ? "none" : "block";
      }
    };

    disableNorthButton(windDirectionData.show);
  }, [windDirectionData.show]); // Runs every time windDirectionData.show changes

  const handleStyleChange = (value) => {
    onStyleChange(value);
  };
  // Function to handle the map style change
  const onStyleChange = (value) => {
    const map = mapRef.current;

    // Change the style of the map
    map.setStyle(value);

    // Re-apply the 3D layer after the style loads, if 3D is active
    map.once("style.load", () => {
      applyMapLanguage(map, i18n.language);
      if (is3DTerrain) {
        apply3DTerrain(map);
      }
      if (is3DBuildings) {
        apply3DBuildings(map);
      }
    });

    setSelectedStyle(value); // Update the selected style in state
  };

  // Toggle 3D terrain
  const toggle3DTerrain = () => {
    const map = mapRef.current;
    setIs3DTerrain(!is3DTerrain);

    if (!is3DTerrain) {
      apply3DTerrain(map);
    } else {
      remove3DTerrain(map);
    }
  };

  // Toggle 3D buildings
  const toggle3DBuildings = () => {
    const map = mapRef.current;
    setIs3DBuildings(!is3DBuildings);

    if (!is3DBuildings) {
      apply3DBuildings(map);
    } else {
      remove3DBuildings(map);
    }
  };

  // Log function to extract zoom level and bounding box
  const logMapData = () => {
    const zoom = mapRef.current.getZoom(); // Get the current zoom level
    const bounds = mapRef.current.getBounds(); // Get the current bounds

    // Get coordinates from bounds
    const minx = bounds.getWest();
    const miny = bounds.getSouth();
    const maxx = bounds.getEast();
    const maxy = bounds.getNorth();
    onUpdateCurrentBounds({ minx, miny, maxx, maxy });
    onUpdateCurrentZoom(zoom);
  };

  // Effect to log updated states
  useEffect(() => {
    if (dfci.show && currentZoom && currentBounds.minx !== undefined) {
      getDfciGrid(
        currentZoom,
        currentBounds.minx,
        currentBounds.miny,
        currentBounds.maxx,
        currentBounds.maxy,
      );
    }
  }, [currentZoom, currentBounds, dfci.show]);

  useEffect(() => {
    getHistoricEventPolygons(userHistoricEventsList.selectedEventIds);
  }, [userHistoricEventsList.selectedEventIds]);

  useEffect(() => {
    if (
      showActiveFiresPanel &&
      activeFires.data === null &&
      !activeFires.isLoading
    ) {
      const { date: fallbackDate, time: fallbackTime } =
        getLocalNowMinusOneHour();
      const startDateToUse = activeFiresStartDate || fallbackDate;
      const startTimeToUse = activeFiresStartTime || fallbackTime;

      if (!activeFiresStartDate) onChangeActiveFiresStartDate(startDateToUse);
      if (!activeFiresStartTime) onChangeActiveFiresStartTime(startTimeToUse);

      if (!activeFires.show) onShowActiveFires();

      getActiveFires(
        startDateToUse,
        activeFiresEndDate,
        startTimeToUse,
        activeFiresEndTime,
      );
    }
  }, [showActiveFiresPanel]);
  useEffect(() => {
    if (selectedFiresIds.length > 0) {
      getHistoricFiresByIds(selectedFiresIds); // Trigger fetch when selected IDs change
    } else {
      setFilteredHistoricFiresPolygons([]);
    }
  }, [selectedFiresIds]);

  useEffect(() => {
    initializeMap(
      mapRef,
      mapContainerRef,
      selectedStyle,
      keyboard,
      store,
      setMoveEvent,
      () => {
        // Called only when map is fully ready
        addMapControls(mapRef);
        initializeDrawTools(triggerTooltip);
        renderDrawToolTooltips();
        renderCustomTooltips();
        applyMapLanguage(mapRef.current, i18n.language);

        if (mapRef.current) {
          mapRef.current.on("zoomend", logMapData);
          mapRef.current.on("moveend", logMapData);
          mapRef.current.on("styledata", () => {
            logMapData();
          });
        }

        logMapData();
      },
    );
    // Cleanup function to remove event listeners and map instance on unmount
    return () => {
      if (mapRef.current) {
        mapRef.current.off("zoomend", logMapData);
        mapRef.current.off("moveend", logMapData);
        mapRef.current.off("styledata");
        mapRef.current.remove();
      }
    };
  }, []);
  useEffect(() => {
    if (!mapRef.current) return;
    renderCustomTooltips();
    renderDrawToolTooltips();
    updateExportContourButtonTooltip();
    updateImportContourButtonTooltip();
    applyMapLanguage(mapRef.current, i18n.language);
  }, [i18n.language]);
  const classificationLayers = useMemo(
    () => [
      ...(vegetationCountry === "france"
        ? [
            {
              id: "dfci",
              title: t("layers.categories.dfci"),
              type: "single",
              description: "DFCi",
              iconClass: <GridViewIcon />,
              items: [
                {
                  name: "Carroyage DFCI",
                  title: t("layers.items.dfciGrid"),
                  onChange: onShowDfci,
                  showItem: dfci.show,
                  ...layerAccess("dfci"),
                },
              ],
            },
          ]
        : []),
      {
        id: "topography",
        title: t("layers.categories.topography"),
        type: "single",
        description: "DFCi",
        iconClass: <TerrainIcon />,
        items: [
          {
            name: "3D",
            title: t("layers.items.3dTerrain"),
            onChange: toggle3DTerrain,
            showItem: is3DTerrain,
            disabled: false,
          },
          {
            name: "demLevel",
            title: t("layers.items.dem"),
            onChange: onShowDemLevel,
            showItem: demLevel.show,
            ...layerAccess("dem"),
          },
        ],
      },
      {
        title: t("layers.categories.access"),
        type: "single",
        description: "DFCi",
        iconClass: <AltRouteIcon />,
        id: "access",
        items: [
          {
            name: "majorRoads",
            title: t("layers.items.roads"),
            onChange: onShowMajorRoads,
            showItem: majorRoads.show,
            ...layerAccess("road"),
          },

          {
            name: "railways",
            title: t("layers.items.railways"),
            onChange: onShowRailways,
            showItem: railways.show,
            ...layerAccess("railways"),
          },
        ],
      },
      {
        title: t("layers.categories.sensitivePoints"),
        type: "multi",
        description: "DFCi",
        iconClass: <FmdBadIcon />,
        id: "sensitive points",
        subcategories: [
          {
            title: t("layers.subcategories.electrical"),
            items: [
              {
                name: "electricalLines",
                title: t("layers.items.electricalLines"),
                onChange: onShowElectricalLines,
                showItem: showElectricalLines,
                ...layerAccess("electrical lines"),
              },
              {
                name: "electricalStations",
                title: t("layers.items.electricalStations"),
                onChange: onShowElectricalStations,
                showItem: showElectricalStations,
                ...layerAccess("electrical stations"),
              },
            ],
          },
          {
            title: t("layers.subcategories.gas"),
            items: [
              {
                name: "gazLines",
                title: t("layers.items.gasMainLines"),
                onChange: onShowGazLines,
                showItem: gazLines.show,
                ...layerAccess("gaz lines"),
              },
              {
                name: "gazRefuelingStations",
                title: t("layers.items.gasStations"),
                onChange: onShowGazRefuelingStations,
                showItem: gazRefuelingStations.show,
                ...layerAccess("gaz stations"),
              },
            ],
          },
        ],
      },

      {
        title: t("layers.categories.waterPoints"),
        type: "single",
        description: "DFCi",
        iconClass: <WaterDropIcon />,
        id: "vegetation",
        items: [
          {
            name: "water",
            title: t("layers.items.naturalWater"),
            onChange: onShowWater,
            showItem: water.show,
            ...layerAccess("water"),
          },
          {
            name: "arttificiel-water",
            title: t("layers.items.artificialWater"),
            onChange: onShowArtificielWater,
            showItem: artificielWater.show,
            ...layerAccess("swiming pool"),
          },
        ],
      },

      {
        title: t("layers.categories.vegetation"),
        type: "mixed",
        description: "DFCi",
        iconClass: <ForestIcon />,
        items: [
          {
            name: "bareSoil",
            title: t("layers.items.bareSoil"),
            onChange: onShowBareSoil,
            showItem: baresoil.show,
            directItem: true,
            ...layerAccess("baresoil"),
          },
          {
            name: "shrubland",
            title: t("layers.items.shrubland"),
            onChange: onShowShrubland,
            showItem: shrubland.show,
            directItem: true,
            ...layerAccess("shrubland"),
          },
          {
            name: "cropland",
            title: t("layers.items.cropland"),
            onChange: onShowCropland,
            showItem: cropland.show,
            directItem: true,
            ...layerAccess("cropland"),
          },
          {
            name: "grassland",
            title: t("layers.items.grassland"),
            onChange: onShowGrassland,
            showItem: grassland.show,
            directItem: true,
            ...layerAccess("grassland"),
          },
          {
            name: "leafAreaIndex",
            title: t("layers.items.leafAreaIndex"),
            onChange: onShowLai,
            showItem: leafAreaIndex.show,
            directItem: true,
            ...layerAccess("lai"),
          },
          {
            name: "vegetationHeight",
            title: t("layers.items.vegetationHeight"),
            onChange: onShowVegetationHeight,
            showItem: vegetationHeight.show,
            directItem: true,
            ...layerAccess("height"),
          },
          {
            name: "biomass",
            title: t("layers.items.biomass"),
            onChange: onShowBiomass,
            showItem: biomass.show,
            directItem: true,
            ...layerAccess("biomass"),
          },
          {
            name: "totalFuelLoad",
            title: t("layers.items.totalFuelLoad"),
            onChange: onShowTotalFuelLoad,
            showItem: totalFuelLoad.show,
            directItem: true,
            ...layerAccess("total fuel load"),
          },
          {
            name: "deadFuel",
            title: t("layers.items.deadFuel"),
            onChange: onShowDeadFuel,
            showItem: deadFuel.show,
            directItem: true,
            ...layerAccess("dfmc"),
          },
        ],
        subcategories: [
          {
            title: t("layers.subcategories.forest"),
            items: [
              {
                name: "coniferous",
                title: t("layers.items.coniferous"),
                onChange: onShowConiferous,
                showItem: coniferous.show,
                ...layerAccess("coniferous"),
              },
              {
                name: "broadleaf",
                title: t("layers.items.broadleaf"),
                onChange: onShowBroadleaf,
                showItem: broadleaf.show,
                ...layerAccess("broadleaf"),
              },
              {
                name: "mixedForest",
                title: t("layers.items.mixedForest"),
                onChange: onShowMixedForest,
                showItem: mixedForest.show,
                ...layerAccess("mixed"),
              },
              {
                name: "pine",
                title: t("layers.items.pine"),
                onChange: onShowPine,
                showItem: pine.show,
                ...layerAccess("pine"),
              },
              {
                name: "oak",
                title: t("layers.items.oak"),
                onChange: onShowOak,
                showItem: oak.show,
                ...layerAccess("oak"),
              },
            ],
          },
        ],
      },

      {
        title: t("layers.categories.urbanization"),
        type: "single",
        description: "DFCi",
        iconClass: <LocationCityIcon />,
        id: "urban",
        items: [
          {
            name: "urban",
            title: t("layers.items.urbanZones"),
            onChange: onShowUrban,
            showItem: urban.show,
            ...layerAccess("urban"),
          },
          {
            name: "3D",
            title: t("layers.items.3dBuildings"),
            onChange: toggle3DBuildings,
            showItem: is3DBuildings,
            disabled: false,
          },
        ],
      },
      ...(vegetationCountry === "france"
        ? [
            {
              title: t("layers.categories.adminBoundaries"),
              type: "single",
              description: "DFCi",
              id: "boundaries",
              iconClass: <CropSquareOutlinedIcon />,
              items: [
                {
                  name: "Régions",
                  title: t("layers.items.regions"),
                  onChange: onShowRegions,
                  showItem: regions.show,
                  ...layerAccess("regions"),
                },
                {
                  name: "Départements",
                  title: t("layers.items.departments"),
                  onChange: onShowDepartements,
                  showItem: departements.show,
                  ...layerAccess("departements"),
                },
              ],
            },
          ]
        : []),
      {
        title: t("layers.categories.sdisInfrastructure"),
        type: "single",
        description: "DFCi",
        iconClass: <LocalFireDepartmentIcon />,
        id: "sdis",
        items: [
          {
            name: "fireStations",
            title: t("layers.items.fireStations"),
            onChange: onShowFireStations,
            showItem: fireStationsData.show,
            ...layerAccess("sdis"),
          },
        ],
      },
    ],
    [
      vegetationCountry,
      canAccessLayer,
      dfci.show,
      is3DTerrain,
      demLevel.show,
      majorRoads.show,
      railways.show,
      showElectricalLines,
      showElectricalStations,
      gazLines.show,
      gazRefuelingStations.show,
      water.show,
      artificielWater.show,
      baresoil.show,
      shrubland.show,
      cropland.show,
      grassland.show,
      leafAreaIndex.show,
      vegetationHeight.show,
      biomass.show,
      totalFuelLoad.show,
      deadFuel.show,
      coniferous.show,
      broadleaf.show,
      mixedForest.show,
      pine.show,
      oak.show,
      urban.show,
      is3DBuildings,
      regions.show,
      departements.show,
      fireStationsData.show,
      onShowDfci,
      toggle3DTerrain,
      onShowDemLevel,
      onShowMajorRoads,
      onShowRailways,
      onShowElectricalLines,
      onShowElectricalStations,
      onShowGazLines,
      onShowGazRefuelingStations,
      onShowWater,
      onShowArtificielWater,
      onShowBareSoil,
      onShowShrubland,
      onShowCropland,
      onShowGrassland,
      onShowLai,
      onShowVegetationHeight,
      onShowBiomass,
      onShowTotalFuelLoad,
      onShowDeadFuel,
      onShowConiferous,
      onShowBroadleaf,
      onShowMixedForest,
      onShowPine,
      onShowOak,
      onShowUrban,
      toggle3DBuildings,
      onShowRegions,
      onShowDepartements,
      onShowFireStations,
    ],
  );
  const weatherLayers = useMemo(
    () => [
      {
        title: t("layers.categories.wind"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-strong-wind",
        id: "wind",
        items: [
          {
            name: "windSpeed",
            title: t("layers.items.windSpeed"),
            onChange: onShowWindSpeedData,
            showItem: windSpeedData.show,
            ...layerAccess("wind_speed", "weather"),
          },
          {
            name: "windGust",
            title: t("layers.items.windGust"),
            onChange: onShowWindGust,
            showItem: windGust.show,
            ...layerAccess("wind_gust", "weather"),
          },
          {
            name: "windDirection",
            title: t("layers.items.windDirection"),
            onChange: onShowWindDirection,
            showItem: windDirectionData.show,
            ...layerAccess("wind_direction", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.temperature"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-thermometer",
        id: "temperature",
        items: [
          {
            name: "temperature",
            title: t("layers.items.temperature"),
            onChange: onShowTemperature,
            showItem: temperature.show,
            ...layerAccess("temperature", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.soilMoisture"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-raindrop",
        id: "soilMoisture",
        items: [
          {
            name: "Soil",
            title: t("layers.items.soilMoisture"),
            onChange: onShowSoilMoisture,
            showItem: soilMoisture.show,
            ...layerAccess("soil_moisture", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.relativeHumidity"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-humidity",
        id: "relativeHumidity",
        items: [
          {
            name: "relativeHumidity",
            title: t("layers.items.relativeHumidity"),
            onChange: onShowRelativeHumidity,
            showItem: relativeHumidity.show,
            ...layerAccess("relative_humidity", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.pressure"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-barometer",
        id: "pressure",
        items: [
          {
            name: "meanSeaLevelPressure",
            title: t("layers.items.meanSeaLevelPressure"),
            onChange: onShowMeanSeaLevelPressure,
            showItem: meanSeaLevelPressure.show,
            ...layerAccess("pr2msl", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.precipitations"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-rain-mix",
        id: "precipitations",
        items: [
          {
            name: "precipitations",
            title: t("layers.items.totalPrecipitation"),
            onChange: onShowPrecipitations,
            showItem: precipitations.show,
            ...layerAccess("total_precipitation", "weather"),
          },
          {
            name: "hourlyPrecipitations",
            title: t("layers.items.hourlyPrecipitation"),
            onChange: onShowHourlyPrecipitations,
            showItem: hourlyPrecipitations.show,
            ...layerAccess("precipitation_1h", "weather"),
          },
        ],
      },
      {
        title: t("layers.categories.cloudCover"),
        type: "single",
        description: "DFCi",
        iconClass: "wi wi-cloudy",
        id: "cloudCover",
        items: [
          {
            name: "cloudCover",
            title: t("layers.items.cloudCover"),
            onChange: onShowCloudCover,
            showItem: cloudCover.show,
            ...layerAccess("cloud", "weather"),
          },
        ],
      },
    ],
    [
      canAccessLayer,
      windSpeedData.show,
      windGust.show,
      windDirectionData.show,
      temperature.show,
      soilMoisture.show,
      relativeHumidity.show,
      meanSeaLevelPressure.show,
      precipitations.show,
      hourlyPrecipitations.show,
      cloudCover.show,
      onShowWindSpeedData,
      onShowWindGust,
      onShowWindDirection,
      onShowTemperature,
      onShowSoilMoisture,
      onShowRelativeHumidity,
      onShowMeanSeaLevelPressure,
      onShowPrecipitations,
      onShowHourlyPrecipitations,
      onShowCloudCover,
    ],
  );
  //important: to ensure that the height of the app interface is responsive
  useEffect(() => {
    const handleResize = () => {
      const viewportHeight = window.innerHeight;
      mapContainerRef.current.style.height = `${viewportHeight - 55}px`;
    };

    window.addEventListener("resize", handleResize);

    // Initialize map on load
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const onOpenLegendComponent = () => {
    handleLegendComponentToggle();
    onShowNavbarMenu();
  };

  useEffect(() => {
    geocoder.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: t("navbar.search.placeholder", {
        defaultValue: "Chercher...",
      }),
      marker: false,
      language: i18n.language,
    });

    if (geocoderContainerRefNavbar.current) {
      geocoderContainerRefNavbar.current.appendChild(
        geocoder.current.onAdd(mapRef.current),
      );
    }

    geocoder.current.on("result", (e) => {
      mapRef.current.flyTo({
        center: e.result.center,
        zoom: 14,
      });
    });

    return () => {
      if (geocoder.current) {
        geocoder.current.onRemove();
      }
    };
  }, [i18n.language]);
  useEffect(() => {
    geocoderSidebar.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: t("eventCreation.origin.addressPlaceholder", {
        defaultValue: "Adresse",
      }),
      marker: false,
      language: i18n.language,
    });

    if (geocoderContainerRefSidebar.current) {
      geocoderContainerRefSidebar.current.appendChild(
        geocoderSidebar.current.onAdd(mapRef.current),
      );
    }

    geocoderSidebar.current.on("result", (e) => {
      onChangeOriginFireLocation(e.result.place_name);
      mapRef.current.flyTo({
        center: e.result.center,
        zoom: 14,
      });
    });

    return () => {
      if (geocoderSidebar.current) {
        geocoderSidebar.current.onRemove();
      }
    };
  }, [mapRef, onChangeOriginFireLocation, i18n.language]);
  return (
    <div
      className={`app-view 
        ${isLightMode ? "light-theme" : "dark-theme"}
      `}
    >
      <MapNavbar
        mapRef={mapRef}
        selectedStyle={selectedStyle}
        handleStyleChange={handleStyleChange}
        handleDraggableComponentToggle={handleDraggableComponentToggle}
        onToggleSidebar={onToggleSidebar}
        handleMeteoComponentToggle={handleMeteoComponentToggle}
        onToggleHistoricSidebar={onToggleHistoricSidebar}
        showHistoricFiresList={showHistoricFiresList}
        onShowHistoricFiresList={onShowHistoricFiresList}
        onShowNavbarMenu={onShowNavbarMenu}
        isSidebarPropagationOpen={isSidebarPropagationOpen}
        isOpenHistoricSidebar={isOpenHistoricSidebar}
        showLayersComponent={showLayersComponent}
        showMeteoComponent={showMeteoComponent}
        toggleMapStylesSidebar={toggleMapStylesSidebar}
        showMapStylesSidebar={showMapStylesSidebar}
        handleLegendComponentToggle={handleLegendComponentToggle}
        showLegendComponent={showLegendComponent}
        logout={logout}
        showUserComponent={showUserComponent}
        onShowUserComponent={onShowUserComponent}
        onShowUserHistoricSection={onShowUserHistoricSection}
        onShowUserProfileSection={onShowUserProfileSection}
        geocoderContainerRefNavbar={geocoderContainerRefNavbar}
        onShowActiveFires={onShowActiveFires}
        onToggleActiveFiresPanel={onToggleActiveFiresPanel}
      />
      {showMapStylesSidebar && (
        <MapStylesSidebar
          selectedStyle={selectedStyle}
          handleStyleChange={handleStyleChange}
          toggleMapStylesSidebar={toggleMapStylesSidebar}
          showMapStylesSidebar={showMapStylesSidebar}
          onShowNavbarMenu={onShowNavbarMenu}
        />
      )}
      {showActiveFiresPanel && (
        <ActiveFiresPanel
          showComponent={showActiveFiresPanel}
          handleDraggableComponentToggle={onToggleActiveFiresPanel}
          isLayerActive={activeFires.show}
          onToggleLayer={onShowActiveFires}
          startDate={activeFiresStartDate}
          endDate={activeFiresEndDate}
          onStartDateChange={onChangeActiveFiresStartDate}
          onEndDateChange={onChangeActiveFiresEndDate}
          onApply={onApplyActiveFiresFilters}
          detectedCount={
            activeFiresBuckets[activeFiresCursor]?.features?.length ?? null
          }
          timelineHours={activeFiresBuckets.length}
          timelineCursor={activeFiresCursor}
          onTimelineCursorChange={onChangeActiveFiresCursor}
          timelineBuckets={activeFiresBuckets}
          isLoading={activeFires.isLoading}
          isSmallScreen={isSmallScreen}
          onShowNavbarMenu={onShowNavbarMenu}
          reducedDragWindow={reducedWindow.activeFiresComponent}
          onReduceDragWindow={onReduceActiveFiresWindow}
          startTime={activeFiresStartTime}
          endTime={activeFiresEndTime}
          onStartTimeChange={onChangeActiveFiresStartTime}
          onEndTimeChange={onChangeActiveFiresEndTime}
          selectedPreset={activeFiresPreset}
          onChangePreset={onChangeActiveFiresPreset}
          displayStartDate={activeFiresDisplayStartDate}
          onChangeDisplayStartDate={onChangeActiveFiresDisplayStartDate}
          displayEndDate={activeFiresDisplayEndDate}
          onChangeDisplayEndDate={onChangeActiveFiresDisplayEndDate}
        />
      )}
      <div
        ref={mapContainerRef}
        className="map-container"
        data-testid="map-container"
      >
        {showCursorCoords && (
          <div className="cursor-coords-div">
            {moveEvent && (
              <>
                {JSON.stringify(moveEvent.point)}
                <br />
                {JSON.stringify(moveEvent.lngLat.wrap())}
              </>
            )}
          </div>
        )}
        {showUserComponent && (
          <UserComponent
            onShowUserComponent={onShowUserComponent}
            showUserComponent={showUserComponent}
            logout={logout}
            updateProfile={updateProfile}
            updatePassword={updatePassword}
            triggerTooltip={triggerTooltip}
            scrollZoom={scrollZoom}
            setScrollZoom={setScrollZoom}
            dragRotate={dragRotate}
            setDragRotate={setDragRotate}
            keyboard={keyboard}
            setKeyboard={setKeyboard}
            showClock={showClock}
            setShowClock={setShowClock}
            showCursorCoords={showCursorCoords}
            setShowCursorCoords={setShowCursorCoords}
            isSmallScreen={isSmallScreen}
            onShowNavbarMenu={onShowNavbarMenu}
            onShowUserHistoricEvents={onShowUserHistoricEvents}
            userHistoricEventsList={userHistoricEventsList}
            handleEventSelect={handleEventSelect}
            activeTab={userComponentActiveTab}
            setActiveTab={setUserComponentActiveTab}
            loadingEventId={loadingEventId}
            onDeselectAllEvents={onDeselectAllEvents}
            onLoadMoreHistoricEvents={loadMoreUserHistoricEvents}
            historicSearchReference={historicSearchReference}
            onChangeHistoricSearchReference={onChangeHistoricSearchReference}
              onDeleteHistoricEvent={onDeleteHistoricEvent}

          />
        )}
        {showNavbarMenu && (
          <NavbarMenu
            showNavbarMenu={showNavbarMenu}
            onShowNavbarMenu={onShowNavbarMenu}
            onToggleHistoricSidebar={onToggleHistoricSidebar}
            onToggleSidebar={onToggleSidebar}
            handleDraggableComponentToggle={handleDraggableComponentToggle}
            handleMeteoComponentToggle={handleMeteoComponentToggle}
            handleLegendComponentToggle={handleLegendComponentToggle}
            toggleMapStylesSidebar={toggleMapStylesSidebar}
            onShowHistoricFiresList={onShowHistoricFiresList}
            onShowUserComponent={onShowUserComponent}
            logout={logout}
            onOpenLegendComponent={onOpenLegendComponent}
            onToggleActiveFiresPanel={onToggleActiveFiresPanel}
          />
        )}
        {showLayersComponent && (
          <DraggableComponent
            handleDraggableComponentToggle={handleDraggableComponentToggle}
            opacities={opacities}
            onHandleOpacity={onHandleOpacity}
            layers={classificationLayers}
            type="terrain"
            showComponent={showLayersComponent}
            onShowNavbarMenu={onShowNavbarMenu}
            isSmallScreen={isSmallScreen}
            reducedDragWindow={reducedWindow.layersComponent}
            onReduceDragWindow={onReduceLayersWindow}
            weatherRequestDate={weatherRequestDate}
            weatherRequestStartHour={weatherRequestStartHour}
            setWeatherRequestDate={setWeatherRequestDate}
            setWeatherRequestStartHour={setWeatherRequestStartHour}
            vegetationCountry={vegetationCountry}
            setVegetationCountry={setVegetationCountry}
            selectedVegDepartment={selectedVegDepartment}
            setSelectedVegDepartment={setSelectedVegDepartment}
            triggerTooltip={triggerTooltip}
          />
        )}
        {showMeteoComponent && (
          <DraggableComponent
            handleDraggableComponentToggle={handleMeteoComponentToggle}
            opacities={opacities}
            onHandleOpacity={onHandleOpacity}
            layers={weatherLayers}
            type="meteo"
            showComponent={showMeteoComponent}
            onShowNavbarMenu={onShowNavbarMenu}
            isSmallScreen={isSmallScreen}
            reducedDragWindow={reducedWindow.weatherComponent}
            onReduceDragWindow={onReduceWeatherWindow}
            weatherRequestDate={weatherRequestDate}
            weatherRequestStartHour={weatherRequestStartHour}
            setWeatherRequestDate={setWeatherRequestDate}
            setWeatherRequestStartHour={setWeatherRequestStartHour}
            weatherCountry={weatherCountry}
            setWeatherCountry={setWeatherCountry}
            selectedWeatherDepartment={selectedWeatherDepartment}
            setSelectedWeatherDepartment={setSelectedWeatherDepartment}
            triggerTooltip={triggerTooltip}
            isDateTimeLocked={anyWeatherVisible}
          />
        )}
        {showLegendComponent && (
          <LegendComponent
            handleLegendComponentToggle={handleLegendComponentToggle}
            showSoilMoisture={soilMoisture.show}
            showRegions={regions.show}
            showDepartements={departements.show}
            showBareSoil={baresoil.show}
            showShrubland={shrubland.show}
            showCropland={cropland.show}
            showGrassland={grassland.show}
            showConiferous={coniferous.show}
            showBroadleaf={broadleaf.show}
            showMixedForest={mixedForest.show}
            showPine={pine.show}
            showOak={oak.show}
            showWater={water.show}
            showArtificielWater={artificielWater.show}
            showUrban={urban.show}
            showWindSpeedData={windSpeedData.show}
            showWindDirection={windDirectionData.show}
            showElectricalLines={showElectricalLines}
            showElectricalStations={showElectricalStations}
            showMajorRoads={majorRoads.show}
            showLegendComponent={showLegendComponent}
            isSmallScreen={isSmallScreen}
            onShowNavbarMenu={onShowNavbarMenu}
            showRailways={railways.show}
            showGazLines={gazLines.show}
            showGazRefuelingStations={gazRefuelingStations.show}
            showPrecipitations={precipitations.show}
            showHourlyPrecipitations={hourlyPrecipitations.show}
            showDeadFuel={deadFuel.show}
            showTemperature={temperature.show}
            showRelativeHumidity={relativeHumidity.show}
            showMeanSeaLevelPressure={meanSeaLevelPressure.show}
            showWindGust={windGust.show}
            showCloudCover={cloudCover.show}
            showFireStations={fireStationsData.show}
            geoJsonResults={geoJsonResults}
            onReduceLegendWindow={onReduceLegendWindow}
            reducedLegendWindow={reducedWindow.legendComponent}
            currentZoom={currentZoom}
            showDem={demLevel.show}
            showBiomass={biomass.show}
            showLai={leafAreaIndex.show}
            showTotalFuelLoad={totalFuelLoad.show}
            showVegHeight={vegetationHeight.show}
            closeAllLayers={closeAllLayers}
            showDfci={dfci.show}
            showActiveFires={activeFires.show}
            showHistoricFires={hasVisibleHistoricFires}
          />
        )}
        {(windDirectionData.show ||
          windSpeedData.show ||
          precipitations.show ||
          hourlyPrecipitations.show ||
          deadFuel.show ||
          temperature.show ||
          relativeHumidity.show ||
          meanSeaLevelPressure.show ||
          cloudCover.show ||
          windGust.show) && (
          <TimelineBar
            sliderIndex={sliderIndex}
            onChangeSliderIndex={onChangeSliderIndex}
            onChangeTime={onChangeTime}
            selectedTime={selectedTime}
            currentTimeZone={currentTimeZone}
            weatherRequestStartHour={weatherRequestStartHour}
            weatherRequestDate={weatherRequestDate}
            setWeatherRequestDate={setWeatherRequestDate}
            setWeatherRequestStartHour={setWeatherRequestStartHour}
            key={timelineKey}
          />
        )}
        {showTooltip && (
          <div
            style={{
              position: "absolute",
              top: "10%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1050,
            }}
          >
            <Tooltip open arrow>
              <div
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#b10511",
                  color: "white",
                  fontSize: "16px",
                  borderRadius: "5px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <WarningAmberIcon />
                {tooltipMessage}
              </div>
            </Tooltip>
          </div>
        )}
        <div className="pitch-controls">
          <IconButton
            onClick={() => changePitch(15)}
            aria-label="increase pitch"
            data-tooltip={t("mapControls.increasePitch")}
            className="mapboxgl-ctrl mapboxgl-ctrl-group custom-control"
            data-testid="increase-pitch-button"
          >
            <ArrowDropUpIcon
              style={{ color: "black", fontSize: "28px" }}
              className="custom-button"
            />
          </IconButton>
          <IconButton
            onClick={() => changePitch(-15)}
            aria-label="decrease pitch"
            data-tooltip={t("mapControls.decreasePitch")}
            className="mapboxgl-ctrl mapboxgl-ctrl-group custom-control"
            data-testid="decrease-pitch-button"
          >
            <ArrowDropDownIcon
              style={{ color: "black", fontSize: "28px" }}
              className="custom-button"
            />
          </IconButton>
          <IconButton
            onClick={
              isSmallScreen
                ? onOpenLegendComponent
                : handleLegendComponentToggle
            }
            aria-label="increase pitch"
            data-tooltip={t("mapControls.legend")}
            className="mapboxgl-ctrl mapboxgl-ctrl-group custom-control"
            data-testid="legend-toggle-button"
          >
            <LayersIcon
              style={{ color: "black", fontSize: "26px" }}
              className="custom-button"
            />
          </IconButton>
        </div>
        <div className="climate-innov-logo">
          <img
            src={assets.companiesLogos}
            alt="Climate Innov logo"
            className="logo-climate-innov"
          />
          {/* <img
            src={assets.edhecLogo}
            alt="EDHEC Climate Institute logo"
            className="logo-edhec"
          /> */}
        </div>
        {showClock && (
          <div className="clockStyle">{time.toLocaleTimeString()}</div>
        )}
        <MapSidebar
          reducedWindow={reducedWindow.eventCreationComponent}
          onReduceEventCreationWindow={onReduceEventCreationWindow}
          isSidebarPropagationOpen={isSidebarPropagationOpen}
          mapRef={mapRef}
          onZoomToGrid={onZoomToGrid}
          dfciCode={dfciCode}
          setDfciCode={setDfciCode}
          windSpeed={windSpeed}
          windDirection={windDirection}
          fuelMoisture={fuelMoisture}
          temperatureParam={temperatureParam}
          handleTemperatureChange={handleTemperatureChange}
          handleWindSpeedChange={handleWindSpeedChange}
          handleWindDirectionChange={handleWindDirectionChange}
          handleFuelMoistureChange={handleFuelMoistureChange}
          geoJsonResults={geoJsonResults}
          toggleContourBuildingsVisibility={toggleContourBuildingsVisibility}
          toggleContourVisibility={toggleContourVisibility}
          geoJsonResultAI={geoJsonResultAI}
          //  selectedOptionModel={selectedOptionModel}
          // onChangeSelectedModel={onChangeSelectedModel}
          selectedMeteoGetOption={selectedMeteoGetOption}
          onChangeSelectedMeteoOption={onChangeSelectedMeteoOption}
          handleSendPolygons={handleSendPolygons}
          getPolygons={getPolygons}
          getPoints={getPoints}
          contourHour={contourHour}
          setContourHour={setContourHour}
          contourDate={contourDate}
          setContourDate={setContourDate}
          triggerTooltip={triggerTooltip}
          currentTimeZone={currentTimeZone}
          formattedCurrentDate={formattedCurrentDate}
          formattedCurrentTime={formattedCurrentTime}
          onChangeOriginFireRef={onChangeOriginFireRef}
          onChangeOriginFireDate={onChangeOriginFireDate}
          onChangeOriginFireHour={onChangeOriginFireHour}
          onChangeOriginFireLocation={onChangeOriginFireLocation}
          originFireRef={originFireRef}
          originFireDate={originFireDate}
          originFireHour={originFireHour}
          originFireLocation={originFireLocation}
          // postOriginFireData={postOriginFireData}
          operationId={operationId}
          handleReset={handleReset}
          handleExport={handleExport}
          onToggleSidebar={onToggleSidebar}
          onShowNavbarMenu={onShowNavbarMenu}
          isSmallScreen={isSmallScreen}
          opacities={opacities}
          onHandleOpacity={onHandleOpacity}
          modelErrorMessage={modelErrorMessage}
          handleResetOpacity={handleResetOpacity}
          geocoderContainerRefSidebar={geocoderContainerRefSidebar}
          setActiveTab={setUserComponentActiveTab}
          onShowUserComponent={onShowUserComponent}
          onShowUserHistoricEvents={onShowUserHistoricEvents}
          currentLoadingMessage={currentLoadingMessage}
          setCurrentLoadingMessage={setCurrentLoadingMessage}
          buildingsLoading={buildingsLoading}
          drawRef={drawRef}
          predictionHours={predictionHours}
          setPredictionHours={setPredictionHours}
          timeStep={timeStep}
          setTimeStep={setTimeStep}
          onShowAllBuildings={onShowAllBuildings}
          onHideAllBuildings={onHideAllBuildings}
          isLightMode={isLightMode}
          geoJsonInputContour={geoJsonInputContour}
        />
        <HistoricSidebar
          onToggleHistoricSidebar={onToggleHistoricSidebar}
          isOpenHistoricSidebar={isOpenHistoricSidebar}
          onChangeHistoricFiresStartDate={onChangeHistoricFiresStartDate}
          onChangeHistoricFiresEndDate={onChangeHistoricFiresEndDate}
          historicFiresEndDate={historicFiresEndDate}
          historicFiresStartDate={historicFiresStartDate}
          showHistoricFiresList={showHistoricFiresList}
          showHistoricFiresByDateList={showHistoricFiresByDateList}
          onShowHistoricFiresList={onShowHistoricFiresList}
          onShowHistoricFiresByDateList={onShowHistoricFiresByDateList}
          formattedCurrentDate={formattedCurrentDate}
          historicFires={historicFires}
          filteredHistoricFires={filteredHistoricFires}
          handleAddFireId={handleAddFireId}
          handleRemoveFireId={handleRemoveFireId}
          selectedFiresIds={selectedFiresIds}
          onShowNavbarMenu={onShowNavbarMenu}
          mapRef={mapRef}
          onReduceHistoricFiresnWindow={onReduceHistoricFiresnWindow}
          reducedWindow={reducedWindow.historicFiresComponent}
          getHistoricFiresByDate={getHistoricFiresByDate}
          getHistoricFires={getHistoricFires}
          defaultHistoricEndDate={defaultHistoricEndDate}
        />
      </div>
    </div>
  );
};

export default React.memo(MapTemplate);
